// Module Name
export const name = 'events';

export const typeEvents = {
    GET_EVENT: `${name}/GET_EVENT`,
};
